<app-spinner-service></app-spinner-service>

<div class="socios-page" [class.socios-page--loading]="isLoading">
<app-toolbar-search (onSearch)="applyFilterGlobal($event)" placeholder="Pesquisar sócios...">
  <div leftContent>
    <button pButton label="Adicionar Sócio" icon="pi pi-plus" class="p-button-success" [disabled]="isLoading" (click)="openNew()"></button>
  </div>
</app-toolbar-search>

<p-table #dt [value]="socios"
  [globalFilterFields]="['nmTrab', 'cpfTrab', 'matricula', 'vrSalFx', 'emailPrinc', 'fonePrinc', 'uf']"
  [paginator]="true" [rows]="10" responsiveLayout="scroll"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
  class="custom-table"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[5, 10, 20, 50]">

  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="nmTrab" style="width: 25%">Nome <p-sortIcon field="nmTrab"></p-sortIcon></th>
      <th pSortableColumn="cpfTrab" style="width: 15%">CPF <p-sortIcon field="cpfTrab"></p-sortIcon></th>
      <th pSortableColumn="matricula" style="width: 10%">Matrícula <p-sortIcon field="matricula"></p-sortIcon></th>
      <th pSortableColumn="vrSalFx" style="width: 15%">Valor Bruto <p-sortIcon field="vrSalFx"></p-sortIcon></th>
      <th pSortableColumn="emailPrinc" style="width: 20%">Email <p-sortIcon field="emailPrinc"></p-sortIcon></th>
      <th pSortableColumn="fonePrinc" style="width: 10%">Telefone <p-sortIcon field="fonePrinc"></p-sortIcon></th>
      <th pSortableColumn="uf" style="width: 5%">UF <p-sortIcon field="uf"></p-sortIcon></th>
      <th style="width: 10%">Ações</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-socio>
    <tr>
      <td>
        <div class="name-content">
          <i class="pi pi-user name-icon"></i>
          <span class="name-text" [pTooltip]="socio.nmTrab" tooltipPosition="top">{{ socio.nmTrab }}</span>
        </div>
      </td>
      <td>
        <div class="cpf-content">
          <i class="pi pi-id-card cpf-icon"></i>
          <span class="cpf-text" [pTooltip]="socio.cpfTrab" tooltipPosition="top">{{ socio.cpfTrab }}</span>
        </div>
      </td>
      <td>
        <div class="matricula-content">
          <i class="pi pi-tag matricula-icon"></i>
          <span class="matricula-text" [pTooltip]="socio.matricula" tooltipPosition="top">{{ socio.matricula }}</span>
        </div>
      </td>
      <td>
        <div class="salary-content">
          <i class="pi pi-dollar salary-icon"></i>
          <span class="salary-text" [pTooltip]="socio.vrSalFx ? (socio.vrSalFx | currency:'BRL':'symbol':'1.2-2') : 'Não informado'" tooltipPosition="top">{{ socio.vrSalFx ? (socio.vrSalFx | currency:'BRL':'symbol':'1.2-2') : '-' }}</span>
        </div>
      </td>
      <td>
        <div class="email-content">
          <i class="pi pi-envelope email-icon"></i>
          <span class="email-text" [pTooltip]="socio.emailPrinc" tooltipPosition="top">{{ socio.emailPrinc }}</span>
        </div>
      </td>
      <td>
        <div class="phone-content">
          <i class="pi pi-phone phone-icon"></i>
          <span class="phone-text" [pTooltip]="socio.fonePrinc" tooltipPosition="top">{{ socio.fonePrinc }}</span>
        </div>
      </td>
      <td>
        <div class="uf-content">
          <i class="pi pi-map-marker uf-icon"></i>
          <span class="uf-text" [pTooltip]="socio.uf" tooltipPosition="top">{{ socio.uf }}</span>
        </div>
      </td>
      <td class="text-center">
        <div class="actions-content">
          <button pButton icon="pi pi-eye" class="p-button-rounded p-button-info action-button" 
            [disabled]="isLoading"
            (click)="verDetalhes(socio)" pTooltip="Ver Detalhes do Sócio" tooltipPosition="top"></button>
          <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-warning action-button" 
            [disabled]="isLoading"
            (click)="editarProLabore(socio)" pTooltip="Editar Pró-Labore" tooltipPosition="top"></button>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="8" class="empty-message">
        <div class="empty-content">
          <i class="pi pi-users" style="font-size: 3rem; color: #6c757d; margin-bottom: 1rem;"></i>
          <h3>Nenhum sócio encontrado</h3>
          <p>Não há sócios cadastrados no sistema.</p>
          <button pButton label="Adicionar Primeiro Sócio" icon="pi pi-plus" (click)="openNew()" class="p-button-success"></button>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog
  [(visible)]="exibirDetalhes"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  header="Detalhes do Sócio"
  styleClass="app-detail-dialog"
  [style]="{ width: '90vw', maxWidth: '1100px' }"
  [breakpoints]="{ '1199px': '95vw', '575px': '98vw' }"
  [contentStyle]="{ overflow: 'auto', maxHeight: '85vh', padding: '0' }">
  <app-socios-detalhes [socio]="socioSelecionado" (close)="exibirDetalhes = false"></app-socios-detalhes>
  <ng-template pTemplate="footer">
    <button pButton label="Fechar" icon="pi pi-times" class="p-button-secondary" (click)="exibirDetalhes = false"></button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="exibirEditarProLabore" [modal]="true" [style]="{width: '90vw', maxWidth: '1300px'}" [draggable]="false" [resizable]="false" [focusOnShow]="false">
  <app-socios-editar-prolabore
    [socio]="socioSelecionado || null"
    (close)="exibirEditarProLabore = false"
    (saved)="onProLaboreSaved($event)">
  </app-socios-editar-prolabore>
</p-dialog>

<div class="p-d-flex p-jc-end" style="margin-top: 1%;">
  <button pButton label="Voltar" icon="pi pi-arrow-left" class="p-button-secondary" [disabled]="isLoading" (click)="voltar()"></button>
</div>
</div>